export default (props) => ({
  __typename: 'ManagerActivationBlock',
})
